// extracted by mini-css-extract-plugin
module.exports = {"bar":"ProgressBar_bar__2MyV7","fill":"ProgressBar_fill__3m-ju"};